var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArraySolid16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.006,
    height: 16.035,
    x: -0.006,
    fill: "#7B868C",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.5 2.035a.5.5 0 1 1 0 1c-.681 0-1.5.113-1.5 1v8c0 .888.819 1 1.5 1a.5.5 0 0 1 0 1c-1.24 0-2.5-.54-2.5-2v-8c0-1.46 1.26-2 2.5-2Zm1.5 6a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2.75 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Zm2 .75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm.25-6.25a.5.5 0 0 1 .5-.5c1.24 0 2.5.54 2.5 2v8c0 1.46-1.26 2-2.5 2a.5.5 0 0 1 0-1c.681 0 1.5-.112 1.5-1v-8c0-.887-.819-1-1.5-1a.5.5 0 0 1-.5-.5Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .035h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArraySolid16);
export default __webpack_public_path__ + "static/media/array_solid_16.6a0230c7399249157d749dce807a12e1.svg";
export { ForwardRef as ReactComponent };